module.exports = __webpack_public_path__ + "img/Comic05-2.335c6442.png";